import {
    budgetAtom,
    cancellationAtom,
    lowDepositAtom,
    hotelCategoryAtom,
    guestRatingAtom,
    mealTypeAtom,
    promoDiscountAtom,
    rebookableAtom,
    reservableAtom,
    roomTypeListAtom,
    attributeListAtom,
    viewTypeListAtom,
    exteriorAtom,
    poolTypeListAtom,
    hotelTransferAtom,
    privateTransferAtom,
    railAndFlyAtom,
    tourOperatorListAtom,
    directFlightAtom,
    withNoBagAtom,
    departureFlightTimeAtom,
    returnFlightTimeAtom,
    accommodationTypeAtom,
} from 'data/Atom/Filter';

import {
    CancellationType,
    HotelCategoryFilter,
    RangeValue,
} from 'types/Search/filter';
import { FormStateHook } from 'types/Search/hook';

import { AccommodationCategory } from 'proto/Accommodation/AccommodationCategory';
import { Attribute } from 'proto/Accommodation/Attributes';
import { Exterior } from 'proto/Offer/Accommodation/Exterior';
import { PoolType } from 'proto/Offer/Accommodation/PoolType';
import { ViewType } from 'proto/Offer/Accommodation/ViewType';
import { MealType } from 'proto/Offer/MealType';
import { RoomType } from 'proto/Offer/Room/RoomType';

import { useSearchAtom } from './useSearchAtom';
import { useSetSearchAtom } from './useSetSearchAtom';

export const useHotelCategory: FormStateHook<Set<HotelCategoryFilter>> = () =>
    useSearchAtom(hotelCategoryAtom);

export const useGuestRating: FormStateHook<number | undefined> = () =>
    useSearchAtom(guestRatingAtom);

export const useMealType: FormStateHook<Set<MealType>> = () =>
    useSearchAtom(mealTypeAtom);

export const useRoomType: FormStateHook<Set<RoomType>> = () =>
    useSearchAtom(roomTypeListAtom);

export const useAccommodationType: FormStateHook<Set<AccommodationCategory>> =
    () => useSearchAtom(accommodationTypeAtom);

export const useCancellation: FormStateHook<CancellationType | undefined> =
    () => useSearchAtom(cancellationAtom);

export const useRebookable: FormStateHook<boolean> = () =>
    useSearchAtom(rebookableAtom);

export const useReservableAtom: FormStateHook<boolean> = () =>
    useSearchAtom(reservableAtom);

export const useLowDepositAtom: FormStateHook<boolean> = () =>
    useSearchAtom(lowDepositAtom);

export const usePromoDiscountAtom: FormStateHook<boolean> = () => {
    return useSearchAtom(promoDiscountAtom);
};

export const useBudgetAtom: FormStateHook<RangeValue<number> | undefined> =
    () => useSearchAtom(budgetAtom);

export const useSetBudgetAtom = () => useSetSearchAtom(budgetAtom);

export const useAttributeListAtom: FormStateHook<Set<Attribute>> = () => {
    return useSearchAtom(attributeListAtom);
};

export const useViewTypeListAtom: FormStateHook<Set<ViewType>> = () =>
    useSearchAtom(viewTypeListAtom);

export const useExteriorAtom: FormStateHook<Set<Exterior>> = () =>
    useSearchAtom(exteriorAtom);

export const usePoolTypeListAtom: FormStateHook<Set<PoolType>> = () =>
    useSearchAtom(poolTypeListAtom);

export const useHotelTransferAtom: FormStateHook<boolean> = () =>
    useSearchAtom(hotelTransferAtom);

export const usePrivateTransferAtom: FormStateHook<boolean> = () =>
    useSearchAtom(privateTransferAtom);

export const useRailAndFlyAtom: FormStateHook<boolean> = () =>
    useSearchAtom(railAndFlyAtom);

export const useTouroperatorListAtom: FormStateHook<Set<string>> = () =>
    useSearchAtom(tourOperatorListAtom);

export const useDirectFlightAtom: FormStateHook<boolean> = () =>
    useSearchAtom(directFlightAtom);

export const useWithNoBagAtom: FormStateHook<boolean> = () =>
    useSearchAtom(withNoBagAtom);

export const useDepartureFlightTimeAtom: FormStateHook<
    RangeValue<number> | undefined
> = () => useSearchAtom(departureFlightTimeAtom);

export const useReturnFlightTimeAtom: FormStateHook<
    RangeValue<number> | undefined
> = () => useSearchAtom(returnFlightTimeAtom);
